import { BrowserRouter, Route, Routes } from "react-router";
import CppPocketGuidePrivacy from "./flutter/cpp_pocket_guide";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<h1>Hii</h1>} />
        <Route
          path="/privacy/cpp_pocket_guide"
          element={<CppPocketGuidePrivacy />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
